/* assets/mega-menu.js — sidebar mega menu OS24 */
(function () {
  'use strict';

  // Calcular altura del header
  function setHeaderH() {
    const h = document.querySelector('sticky-header, .header-wrapper, header');
    if (h) document.documentElement.style.setProperty('--os24-header-h', h.getBoundingClientRect().bottom + 'px');
  }
  setHeaderH();
  window.addEventListener('scroll', setHeaderH, { passive: true });
  window.addEventListener('resize', setHeaderH, { passive: true });

  const backdrop = document.querySelector('.os24-mega-backdrop');
  let activeBtn  = null;

  function openPanel(btn) {
    if (activeBtn && activeBtn !== btn) closeAll();
    const panelId = btn.getAttribute('aria-controls');
    const panel   = document.getElementById(panelId);
    if (!panel) return;
    setHeaderH();
    btn.setAttribute('aria-expanded', 'true');
    panel.removeAttribute('hidden');
    if (backdrop) backdrop.classList.add('is-active');
    activeBtn = btn;
  }

  function closeAll() {
    document.querySelectorAll('.os24-mega-trigger[aria-expanded="true"]').forEach(b => {
      b.setAttribute('aria-expanded', 'false');
      const p = document.getElementById(b.getAttribute('aria-controls'));
      if (p) p.setAttribute('hidden', '');
    });
    if (backdrop) backdrop.classList.remove('is-active');
    activeBtn = null;
  }

  // Triggers del nav
  document.querySelectorAll('.os24-mega-trigger').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      btn.getAttribute('aria-expanded') === 'true' ? closeAll() : openPanel(btn);
    });
  });

  // Sidebar tabs
  document.querySelectorAll('.os24-mega-sidebar__item').forEach(item => {
    item.addEventListener('click', () => {
      const targetId = item.dataset.target;
      const panel    = item.closest('.os24-mega-panel__inner');
      if (!panel) return;

      panel.querySelectorAll('.os24-mega-sidebar__item').forEach(i => i.classList.remove('is-active'));
      panel.querySelectorAll('.os24-mega-subpanel').forEach(p => p.classList.remove('is-active'));

      item.classList.add('is-active');
      const target = document.getElementById(targetId);
      if (target) target.classList.add('is-active');
    });
  });

  // Cerrar backdrop
  if (backdrop) backdrop.addEventListener('click', closeAll);

  // Escape
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });

  // Click fuera
  document.addEventListener('click', e => {
    if (!e.target.closest('.os24-mega-wrap') && !e.target.closest('.os24-mega-panel')) closeAll();
  });

  // Scroll largo
  let lastY = window.scrollY;
  window.addEventListener('scroll', () => {
    if (Math.abs(window.scrollY - lastY) > 100) { closeAll(); lastY = window.scrollY; }
  }, { passive: true });

})();
